var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_c('i',{staticClass:"fad fa-user-cog",attrs:{"aria-hidden":"true"}}),_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('h2',{staticClass:"text-muted"},[_vm._v(_vm._s(_vm.leaName))])])}
var staticRenderFns = []

export { render, staticRenderFns }